import { Container, Button, Form, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;

    await axios.post("/api/auth/register", { email, password });
    alert("Check your email to verify");
  };

  return (
    <Container style={{ height: "80vh" }} className="d-flex justify-content-center align-items-center">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}>
        <Card className="p-4 shadow-lg border-0" style={{ width: 400 }}>
          <h2 className="text-gradient text-center mb-3">Register</h2>

          <Form onSubmit={handleSubmit}>
            <Form.Control
              name="email"
              placeholder="Email"
              className="mb-3"
            />
            <Form.Control
              name="password"
              type="password"
              placeholder="Password"
              className="mb-3"
            />

            <Button
              type="submit"
              variant="success"
              className="w-100 fw-bold mb-3"
            >
              Create Account
            </Button>
          </Form>

          <div className="text-center">
            <Button
              variant="link"
              className="p-0"
              onClick={() => navigate("/login")}
            >
              Already have an account? Login
            </Button>
          </div>
        </Card>
      </motion.div>
    </Container>
  );
}
